import { useMutation } from '@apollo/client'
import { DenyGroupClearanceStatus, DenyGroupClearanceStatusVariables } from '../../types'
import { DENY_GROUP_CLEARANCE_STATUS } from './operations'

export const useDenyGroupClearanceStatus = () =>
  useMutation<DenyGroupClearanceStatus, DenyGroupClearanceStatusVariables>(
    DENY_GROUP_CLEARANCE_STATUS
  )
